import { trackingService } from '../lib/tracking/tracking-service';

export type TrackEventProps = Record<string, unknown>;

/**
 * Abstraction over the tracking service for custom (non page view) events.
 * Provides semantic helpers so call sites don't depend on raw event names.
 */
class EventTracker {
  /**
   * Track an arbitrary custom event across all trackers
   */
  track(eventName: string, props?: TrackEventProps): Promise<void> {
    return trackingService.trackEvent(eventName, props);
  }

  /**
   * Track a click on a named element (button, link, etc.)
   * @param elementId - Stable identifier for the clicked element
   * @param props - Optional extra properties to attach to the event
   */
  trackClick(elementId: string, props?: TrackEventProps): Promise<void> {
    return this.track('click', { element_id: elementId, ...props });
  }
}

export const eventTracker = new EventTracker();
